import script from "./H2Display.vue?vue&type=script&lang=ts&setup=true"
export * from "./H2Display.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__